var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "disclaimer-bar" },
    [
      _c("i", { staticClass: "el-icon-warning-outline disclaimer-icon" }),
      !_vm.isEditing
        ? [
            _c("span", { staticClass: "disclaimer-text" }, [
              _vm._v(_vm._s(_vm.content || "（尚無公告）")),
            ]),
            _vm.isAdmin
              ? _c(
                  "el-button",
                  {
                    staticClass: "disclaimer-btn",
                    attrs: { type: "text", size: "mini", icon: "el-icon-edit" },
                    on: { click: _vm.handleEditting },
                  },
                  [_vm._v(" 編輯 ")]
                )
              : _vm._e(),
          ]
        : [
            _c("el-input", {
              staticClass: "disclaimer-input",
              attrs: {
                size: "mini",
                type: "textarea",
                autosize: { minRows: 1, maxRows: 4 },
                maxlength: "500",
              },
              model: {
                value: _vm.tempContent,
                callback: function ($$v) {
                  _vm.tempContent = $$v
                },
                expression: "tempContent",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "disclaimer-btn save",
                attrs: {
                  type: "primary",
                  size: "mini",
                  loading: _vm.isLoading,
                },
                on: { click: _vm.handleSave },
              },
              [_vm._v(" 儲存 ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "disclaimer-btn",
                attrs: { size: "mini", loading: _vm.isLoading },
                on: { click: _vm.handleClose },
              },
              [_vm._v(" 取消 ")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }